import { FC } from "react";

import { OverviewSourceUsageTooltipProps } from "./types";
import { formatTooltipHeader } from "./utils/formatTooltipHeader";
import { formatValue } from "./utils/formatValue";

import styles from "./OverviewSourceUsageTooltip.module.css";

const OverviewSourceUsageTooltip: FC<OverviewSourceUsageTooltipProps> = ({
  active,
  payload,
  label,
}) => {
  if (!active || !payload?.length || !label) {
    return null;
  }

  const fullDate = formatTooltipHeader(String(label));

  return (
    <div
      className={styles["overview_source_usage_tooltip"]}
      role="tooltip"
      aria-label="Chart data for date"
    >
      <header className={styles["overview_source_usage_tooltip__header"]}>
        <time className={styles["overview_source_usage_tooltip__month_year"]}>
          {fullDate}
        </time>
      </header>
      <ul
        className={styles["overview_source_usage_tooltip__list"]}
        aria-label="Source usage by series"
      >
        {payload.map((item) => (
          <li
            key={item.dataKey ?? item.name}
            className={styles["overview_source_usage_tooltip__row"]}
            role="listitem"
          >
            <span
              className={styles["overview_source_usage_tooltip__swatch"]}
              style={{ backgroundColor: item.color ?? "currentColor" }}
              aria-hidden
            />
            <h4 className={styles["overview_source_usage_tooltip__name"]}>
              {item.name}
            </h4>
            <span className={styles["overview_source_usage_tooltip__value"]}>
              {formatValue(item.value)}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default OverviewSourceUsageTooltip;
